import { AmbientLight, DirectionalLight } from 'three'

export class Lights {
    constructor(scene) {
        this.ambient = new AmbientLight(0xffffff, 0.4)
        scene.add(this.ambient)

        this.key = new DirectionalLight(0xfff0ee, 1.54)
        this.key.position.set(-5, 10, 10)
        this.key.castShadow = true
        this.key.shadow.mapSize.width = 1024
        this.key.shadow.mapSize.height = 1024
        this.key.shadow.camera.near = 0.5
        this.key.shadow.camera.far = 40
        this.key.shadow.camera.left = -5
        this.key.shadow.camera.right = 5
        this.key.shadow.camera.top = 5
        this.key.shadow.camera.bottom = -5
        this.key.shadow.radius = 24
        this.key.shadow.blurSamples = 24
        this.key.shadow.bias = -0.002
        scene.add(this.key)
    }
}
